import React from "react";
import {
    ApiOutlined,
    DashboardOutlined,
    DollarCircleOutlined, DownloadOutlined,
    FieldTimeOutlined, FileDoneOutlined,
    PaperClipOutlined,
    PartitionOutlined, PoundCircleOutlined, ToolOutlined
} from "@ant-design/icons";

export const getIconDashboard = () => {
    return <DashboardOutlined />
}

export const getIconLLMModel = () => {
    return <ApiOutlined />
}

export const getIconPipeline = () => {
    return <PartitionOutlined />
    // return <FontAwesomeIcon icon={["fas", "sync"]} />
}

export const getIconLatency = () => {
    return <FieldTimeOutlined />
    // return <FontAwesomeIcon icon={["far", "clock"]} />
}

export const getIconDocument = () => {
    return <PaperClipOutlined />
}

export const getIconCost = () => {
    return <PoundCircleOutlined />
}


export const getIconProcessor = () => {
    return <ToolOutlined />
}


export const getIconResponse = () => {
    return <DownloadOutlined />
}

export const getIconToken = () => {
    return <FileDoneOutlined />
}
